import React from "react";
import { default as WBreadcrumbs } from "@mui/material/Breadcrumbs";

function Breadcrumbs(props) {
  return <WBreadcrumbs {...props} />;
}

export default Breadcrumbs;
